export function fetchConfig(context) {
  return context.gateways.configurationGateway.fetchConfig();
}
